import { z } from "zod";

export const HealthResponse = z.object({
  status: z.enum(["ok", "degraded"]),
  database: z.enum(["ok", "down"]),
});
export type HealthResponse = z.infer<typeof HealthResponse>;
